// ============================================
// UI - Utility para combinar clases CSS
// ============================================

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combinar clases de Tailwind evitando conflictos
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Capitalizar texto: primera letra de cada palabra en mayúscula
 * @param text - Texto a capitalizar
 * @returns Texto con cada palabra comenzando en mayúscula
 */
export function capitalize(text: string | null | undefined): string {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Formatear número de teléfono chileno al formato +56 # #### ####
 * @param phone - Número de teléfono a formatear
 * @returns Teléfono formateado
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';
  
  // Limpiar: solo números
  const cleaned = phone.replace(/\D/g, '');
  
  // Si está vacío después de limpiar
  if (!cleaned) return '';
  
  let phoneNumber = cleaned;
  
  // Caso 1: Ya tiene 56 al inicio (11 dígitos: 56XXXXXXXXX)
  if (cleaned.length === 11 && cleaned.startsWith('56')) {
    phoneNumber = cleaned.substring(2); // Remueve el 56
  }
  // Caso 2: Tiene 9 dígitos (XXXXXXXXX)
  else if (cleaned.length === 9) {
    phoneNumber = cleaned;
  }
  // Si no cumple con los formatos esperados, retornar original
  else {
    return phone;
  }
  
  // Formatear: +56 # #### ####
  if (phoneNumber.length === 9) {
    return `+56 ${phoneNumber[0]} ${phoneNumber.substring(1, 5)} ${phoneNumber.substring(5)}`;
  }
  
  return phone;
}
